var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 10.5C18.125 7.60938 16.5625 4.95312 14.0625 3.46875C11.5234 2.02344 8.4375 2.02344 5.9375 3.46875C3.39844 4.95312 1.875 7.60938 1.875 10.5C1.875 13.4297 3.39844 16.0859 5.9375 17.5703C8.4375 19.0156 11.5234 19.0156 14.0625 17.5703C16.5625 16.0859 18.125 13.4297 18.125 10.5ZM0 10.5C0 6.94531 1.875 3.66406 5 1.86719C8.08594 0.0703125 11.875 0.0703125 15 1.86719C18.0859 3.66406 20 6.94531 20 10.5C20 14.0938 18.0859 17.375 15 19.1719C11.875 20.9688 8.08594 20.9688 5 19.1719C1.875 17.375 0 14.0938 0 10.5ZM9.0625 5.1875C9.0625 4.67969 9.45312 4.25 10 4.25C10.5078 4.25 10.9375 4.67969 10.9375 5.1875V10.0312L14.2578 12.2188C14.6875 12.5312 14.8047 13.1172 14.5312 13.5469C14.2188 13.9766 13.6328 14.0938 13.2031 13.7812L9.45312 11.2812C9.21875 11.125 9.0625 10.8125 9.0625 10.5V5.1875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/time-icon.b87abcdf67070cc58afbba2e0d148a58.svg";
export { ForwardRef as ReactComponent };